export enum PersonProfileItemType {
    Text = "Text",
    Date = "Date",
    RichText = "RichText",
    Country = "Country",
}
